// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  defaultauth: 'firebase',
  firebaseConfig: {
    apiKey: "AIzaSyB1H_quHOWVcuzYsEvsDamXwRSU-E2z4fE",
    authDomain: "snsm-propv01.firebaseapp.com",
    projectId: "snsm-propv01",
    storageBucket: "snsm-propv01.appspot.com",
    messagingSenderId: "843840460517",
    appId: "1:843840460517:web:dc32c47396d027e3c3a60c",
    measurementId: "G-QJSCJ56R0Z"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
